import _ from "lodash";
import { APP_VERSION } from '../actions/types';
import { constants } from '../Constants/constants';

const INITIAL_STATE = {
    ui: {
        appVersion: _.cloneDeep(constants.APP_VERSION_INPUT)
    }
}

const appVersionReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case APP_VERSION.SET_APP_VERSION_DEFAULT:
            return Object.assign({}, INITIAL_STATE)
        case APP_VERSION.SET_APP_VERSION:
        case APP_VERSION.SET_APP_VERSION_VALUE:
            return Object.assign({}, {
                ...state,
                ui: {
                    ...state.ui,
                    appVersion: action.appVersion
                }
            })
        default:
            return state
    }
}

export default appVersionReducer